import React from 'react';
import { Header, ResourceSection, Footer } from '../containers';

const Browse = () => {
  return (
    <div>
      <Header />
      <ResourceSection />
      <Footer />
    </div>
  );
};

export default Browse;
